<template>
  <section class="new-benchmarks">
    <HeadingWithDescription
      :size-heading="32"
      :text-heading="labels.title"
      :text-description="labels.description"
    />

    <FormNewBenchmarks />
  </section>
</template>

<script>
import { HeadingWithDescription } from '@/components/content/HeadingWithDescription';
import { FormNewBenchmarks } from '@/components/content/FormNewBenchmarks';
import { changePageTitle } from '@/utils';

export default {
  name: 'NewBenchmarks',
  components: {
    HeadingWithDescription,
    FormNewBenchmarks,
  },
  data() {
    return {
      labels: {
        title: 'Novo Benchmarks',
        description: 'Pra começar precisamos das seguintes informações',
      },
    };
  },
  created() {
    changePageTitle('Novo Benchmarks');
  },
};
</script>

<style scoped lang="scss">
.new-benchmarks {
  width: 100%;
}
</style>
